import React from "react";

export default function ProfileSquelette({ children }) {
  return (
    <div className="tyn-content tyn-content-page">
      <div className="tyn-main tyn-content-inner">
        <div className="container">
          <div className="tyn-profile">{children}</div>
        </div>
      </div>
    </div>
  );
}
